import { IconButton, AppBar, Toolbar } from "@material-ui/core";
import * as React from "react";
import { VisibilityOutlined, Edit, MoreVert } from "@material-ui/icons";
import { Theme } from "@material-ui/core/styles";

import { observable, action, toJS } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { Route, RouteComponentProps, Switch } from "react-router";
import { observer } from "mobx-react";
import { companiesAdminStore } from ".";

import { history } from "src/history.js";
import { Loading } from "src/components/loading";

import { default as ReactTable, ReactTableDefaults } from "react-table";
import "react-table/react-table.css";

import { AdminToolBar } from "src/modules/admin/components";
import { CompaniesAdminDetails } from "./components";
import { permissionsStore } from "src/modules/admin/modules/Permissions";
import { authStore } from "src/modules/auth";
import { MaterialSwitch } from "../UsersAdmin/switch"; //B-014
import "../UsersAdmin/actionBtn.css"; //E-042.1

const styles = ({ typography }: Theme) =>
  createStyles({
    root: {
      height: "100%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    table: {
      height: "100%",
      flex: 1,
      fontFamily: "inherit",
    },
    tableIconCell: {
      display: "flex",
      justifyContent: "center",
    },
    tableIconHeader: {
      marginRight: "1rem",
    },
    tableDefaultCell: {
      marginRight: ".25rem",
      marginLeft: ".25rem",
      display: "flex",
      alignItems: "center",
      fontFamily: typography.fontFamily,
    },
    tableDefaultHeader: {
      fontFamily: typography.fontFamily,
    },
    content: {
      flex: 1,
      display: "flex",
    },
  });
  interface IProps {
}

interface IState {
  filters?: any;
}

@observer
class CompaniesAdmin extends React.Component<any,IState> {
  @observable
  public module: "table" | "details";

  @observable
  public loaded: boolean = false;

  @observable
  public showDisabled: boolean = false; // B-014

  @observable
  public data: any;

  protected columns = [
    {
      Header: "Company",
      accessor: "CompanyName",
      Filter: ({ filter, onChange }) => (
        <input
          type="text"
          style={{ width: "100%" }}
          defaultValue={filter ? filter.value : this.state.filters["CompanyName"]}
          onKeyUp={event => {
            onChange(event.currentTarget.value);
            if (event.currentTarget.value.length === 0) {
              let filterInfo: any = localStorage.getItem("companyFilter");
              let filter: any = JSON.parse(filterInfo);
              delete filter.CompanyName;
              localStorage.setItem("companyFilter", JSON.stringify(filter));
            }
          }}
        />
      ),
    },
    {
      Header: "Location",
      id: "Location",
      // accessor: (a:any) => (!a.CompanyCity && !a.CompanyState) ? '' : a.CompanyCity + ', ' + a.CompanyState
      accessor: (a: any) => {
        if (!a.CompanyCity && !a.CompanyState) {
          return "";
        } else if (!a.CompanyCity) {
          return a.CompanyState;
        } else if (!a.CompanyState) {
          return a.CompanyCity;
        }
        return a.CompanyCity + ", " + a.CompanyState;
      },
      Filter: ({ filter, onChange }) => (
        <input
          type="text"
          style={{ width: "100%" }}
          defaultValue={filter ? filter.value : this.state.filters["Location"]}
          onKeyUp={event => {
            onChange(event.currentTarget.value);
            if (event.currentTarget.value.length === 0) {
              let filterInfo: any = localStorage.getItem("companyFilter");
              let filter: any = JSON.parse(filterInfo);
              delete filter.Location;
              localStorage.setItem("companyFilter", JSON.stringify(filter));
            }
          }}
        />
      ),
    },
    {
      Header: "Email",
      accessor: "CompanyEmail",
      Filter: ({ filter, onChange }) => (
        <input
          type="text"
          style={{ width: "100%" }}
          defaultValue={filter ? filter.value : this.state.filters["CompanyEmail"]}
          onKeyUp={event => {
            onChange(event.currentTarget.value);
            if (event.currentTarget.value.length === 0) {
              let filterInfo: any = localStorage.getItem("companyFilter");
              let filter: any = JSON.parse(filterInfo);
              delete filter.CompanyEmail;
              localStorage.setItem("companyFilter", JSON.stringify(filter));
            }
          }}
        />
      ),
    },
  //  e-42.1
  {
    Header: "Actions",
    accessor: (a: any) => this.groupActionBtn(a),
    id: "company_id",
    className: this.props.classes.tableIconCell,
    sortable: false,
    resizable: true,
    filterable: false,
    width: 90,
    alignItems: "center",
  },
  ];
  constructor(props: IProps) {
    super(props);
    this.state = {
      filters: {},
    };
  }

  public groupActionBtn = (row: any) => {
    return (
      <label className="dropdown">
        <div className="dd-button">
          <MoreVert fontSize="small" />
        </div>
        <input type="checkbox" className="dd-input" id="test" />
        <ul className="dd-menu">
          <li>
            <div
              style={{
                display: `flex`,
                flexDirection: "row",
              }}
            >
              <IconButton
                color={"default"}
                onClick={this.navOnClick(
                  `/admin/companies/edit/${row.company_id}`
                )}
                style={{ padding: ".375rem" }}
              >
                <Edit fontSize="small" />
              </IconButton>
 
              <IconButton
                color={"default"}
                onClick={this.navOnClick(
                  `/admin/companies/detail/${row.company_id}`
                )}
                style={{ padding: ".375rem" }}
              >
                <VisibilityOutlined fontSize="small" />
              </IconButton>
            </div>
          </li>
        </ul>
      </label>
    );
  };

  public filterCaseInsensitive = (filter: any, row: any) => {
    const id = filter.pivotId || filter.id;
    const content = row[id];
    if (typeof content !== "undefined") {
      // filter by text in the table or if it's a object, filter by key
      if (typeof content === "object" && content !== null && content.key) {
        return String(content.key)
          .toLowerCase()
          .includes(filter.value.toLowerCase());
      } else {
        return String(content)
          .toLowerCase()
          .includes(filter.value.toLowerCase());
      }
    }
    return true;
  };
//E-019
  public handleFilterChange = (columnId, value) => {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [columnId]: value,
      },
    }));
  };

  public navOnClick =
    (link: string) =>
    (e: React.MouseEvent): void => {
      history.push(link);
    };

    /**
   * function to handle styling of the disabled users while click on the button Company  B-014
   */
    getTrProps = (state, rowInfo, instance) => {
    if (rowInfo) {
      return {
        style: {
          background: rowInfo
            ? rowInfo.original.PortalDeletedAt !== null
              ? "#a9a9a9"
              : "none"
            : "none"
        }
      };
    }
    return {};
    };


    /**
     * function toTMPS > Companies - Ability to Disable Company  B-014
     */
    public handleToggleBtn = () => {
      this.showDisabled = !this.showDisabled;
      companiesAdminStore.retrieveCompanies();
      history.push("/admin/companies");
    };

    public componentDidMount = async () => {
        await companiesAdminStore.retrieveCompanies();
        let d: any = localStorage.getItem("companyFilter");
        let val: any = JSON.parse(d);
        if (val) {
          this.setState({ filters: val });
        }
      };
  
  //B-014 MaterialSwitch
  public render() {
    if (Object.entries(this.state.filters).length != 0) {
        localStorage.setItem("companyFilter", JSON.stringify(this.state.filters));
      }
    const { classes } = this.props;
    if (!companiesAdminStore.loaded) {
      return <Loading />;
    }
    return (
      <div className={classes.root}>
        <AdminToolBar pageTitle={"Company"} />
        <div style={{display:"flex", justifyContent:"flex-end"}} className={this.props.classes.btnPosition}> 
            <MaterialSwitch
              label={"Show Disabled"}
              value="true"
              onChange={this.handleToggleBtn}
            />
        </div>
        <div className={classes.content}>
          <Switch>
            <Route path={"/admin/companies"} render={this.tableRender} />
          </Switch>
        </div>
      </div>
    );
  }
// TMPS > Companies - Ability to Disable Company B-014 getTrProps, data
  protected tableRender = () => {
    const { filters } = this.state;
    if (companiesAdminStore.loaded) {
      return (
        <ReactTable
          column={{
            ...ReactTableDefaults.column,
            resizable: true,
            filterable: true,
            className: this.props.classes.tableDefaultCell,
            headerClassName: this.props.classes.tableDefaultHeader,
          }}
          data={this.showDisabled === false? companiesAdminStore.all_companies.filter(item =>item.PortalDeletedAt == null) :companiesAdminStore?.all_companies} // HERE THIS FUNCTION FOR WHICH HAVE PORTAL DELETED NULL B-014
          columns={this.columns}
          style={{ height: "70%", flex: 1 }}
          className="-striped -highlight"
          getTrProps={this.getTrProps}
          defaultFilterMethod={this.filterCaseInsensitive}
          filtered={Object.entries(filters).map(([columnId, value]) => ({
            id: columnId,
            value: value,
          }))}
          onFilteredChange={filtered => {
            const newFilters = {};
            filtered.forEach(filter => {
              newFilters[filter.id] = filter.value;
            });
            this.setState({ filters: newFilters });
          }}
        />
      );
    } else {
      return <Loading />;
    }
  };


  protected detailsRender = (mode: string) => () => {
    return <CompaniesAdminDetails mode={mode} />;
  };
}

export default withStyles(styles, { withTheme: true })(CompaniesAdmin);



// WEBPACK FOOTER //
// ./src/modules/admin/modules/CompaniesAdmin/CompaniesAdmin.tsx